import axios from 'axios';
import vehicle from 'constants/vehicle';
let apiUrl = process.env.REACT_APP_API_URL;

const getConstantVehicle = () => vehicle;

const getDefaultVersions = () => [
  { id: '-1', name: 'No encuentro la versión' },
  { id: '-2', name: 'No sé la versión' },
  { id: '-4', name: 'Mostrar todas las versiones del año' },
  { id: '-3', name: 'Mostrar todas las versiones del modelo' }
];
const getDefaultVersionsNoModel = () => [
  { id: '-1', name: 'No encuentro la versión' },
  { id: '-2', name: 'No sé la versión' },
  { id: '-4', name: 'Mostrar todas las versiones del año' }
];
const getModels = (brands: any, brandId: any) => {
  let brand = brands?.find((b: any) => b.id === parseInt(brandId));
  if (brand) {
    return brand.Models;
  }
  return [];
};
const getVehicleFeatures = (versions: any, versionId: any) => {
  return versions.find((v: any) => v.id === parseInt(versionId));
};
const getBrands = async (type: any) => {
  try {
    const response = await axios.get(`${apiUrl}/brands/${type}`);
    return response.data;
  } catch (error) {
    return null;
  }
};
const getBranchBrands = async (brands: any) => {
  try {
    const response = await axios.get(`${apiUrl}/branchBrands`);
    if(response.data === undefined || response.data.length == 0) {
      return brands;
    }
    const brandIds = response.data.map((b: any) => b.brand_id);
    const finalBrands = brands?.filter((b: any) => brandIds.includes(b.id));
    if (finalBrands) {
      return finalBrands;
    }
    return brands;
  } catch (error) {
    return brands;
  }
};
const getVersions = async (model: any, year: any) => {
  try {
    const response = await axios.get(`${apiUrl}/versions/${model}/${year}`);
    return response.data;
  } catch (error) {
    return null;
  }
};
  
const getVehicleInfo = async (license: any) => {
  try {
    const response = await axios.get(`${apiUrl}/patents/${license}`);
    return response.data;
  } catch (error) {
    return null;
  }
};

const getCompanyData = async () => {
  try {
    const response = await axios.get(`${apiUrl}/companyData`);
    return response.data;
  } catch (error) {
    return null;
  }
};

const getSubversions = async (versionId: any) => {
  try {
    const response = await axios.get(`${apiUrl}/subversions/${versionId}`);
    return response.data;
  } catch (error) {
    return null;
  }
};

const getAssociatedRebuyers = async () => {
  try {
    const response = await axios.get(`${apiUrl}/info/associated_rebuyers`);
    return response.data;
  } catch (error) {
    return null;
  }
};

const getRegions = async () => {
  try {
    const response = await axios.get(`${apiUrl}/info/regions`);
    return response.data;
  } catch (error) {
    return null;
  }
};

const getTableColumns = async () => {
  try {
    const response = await axios.get(`${apiUrl}/users/table_columns`);
    return response.data.table_columns;
  } catch (error) {
    return null;
  }
};

const setTableColumns = async (data: any) => {
  try {
    const response = await axios.post(`${apiUrl}/users/set_table_columns/`, data);
    return response.data;
  } catch (error) {
    return null;
  }
};

const getAge = () => {
  const min_age = 0;
  const max_age = 16;

  return Array(max_age - min_age)
    .fill(1)
    ?.map((_, i) => ({ id: min_age + i, name: min_age + i }));
};
const getYears = () => {
  const max_year = new Date().getFullYear();

  return Array(15)
    .fill(1)
    ?.map((_, i) => ({ id: max_year - i, name: max_year - i }));
};

const dataService: any = {
  getConstantVehicle,
  getBrands,
  getCompanyData,
  getModels,
  getVersions,
  getVehicleInfo,
  getDefaultVersions,
  getDefaultVersionsNoModel,
  getVehicleFeatures,
  getSubversions,
  getAssociatedRebuyers,
  getRegions,
  getAge,
  getYears,
  getTableColumns,
  setTableColumns,
  getBranchBrands,
};
export default dataService;
